<template>
  <div :id="'radio--' + component_id">
    <div class="designeroption sbdoption" v-if="options_loaded && passed_filter && panel_required" data-designer-component-id="secured_by_design">
      <h3>Secured By Design</h3>
      <div class="stylesoption">
        <div class="radiooption stylesoption">
          <span>Would you like to upgrade to SBD?</span>
          <span v-for="option in filtered_option_list"><label><input type="radio" v-model="localTarget"
                                                                     :name="'radio_' + component_id"
                                                                     :value="option.value"/> {{ option.label }}</label></span>
        </div>
        <p>
          To ensure your new door meets the stringent security standards specified by Secured by Design, your specification will be as follows:
        </p>
        <p v-html="body_text">
        </p>
        <div class="features">
          <span><img :src="'/images/solarcalibre/multipoint-locking.png'" alt=""/><br>Multipoint Lock</span>
          <span><img :src="'/images/solarcalibre/spyhole.png'" alt=""/><br>Spy Hole</span>
          <span><img :src="'/images/solarcalibre/security-chain.png'" alt=""/><br>Security Chain</span>
          <span><img :src="'/images/solarcalibre/sbd.png'" alt="" style="max-width: 208px;"/></span>
        </div>
      </div>
    </div>
  </div>


</template>

<script type="text/ecmascript-6">
import DesignerQuestionSecuredByDesign from "../DesignerQuestionSecuredByDesign.vue";

export default {
  mixins: [
      DesignerQuestionSecuredByDesign
  ],
  props: {
    slab: {
      required: true,
    },
      body_text: {
          required: false,
          default() {
              return '6.8mm Toughened/Laminated Glazing, Spy Hole, TS008 Letter Plate (if letterplate required), Security Chain, Multipoint Lock, 3* Cylinder with Lever / Lever or Lever / Pad Handle or TS007 2* Handle with 1* Cylinder.';
          }
      }
  },
  computed: {
    passed_filter(){
      return this.variable_ready(this.slab);
    },
    url(){
      return '/api/options/' + this.fabricator + '/secured-by-design?slab=' + this.slab;
    },
    cache_key(){
      return '_' + this.slab;
    },
    panel_required() {
      return this.filtered_option_list.length > 1;
    }
  },
  watch: {
    'slab': function (val, oldVal) {
      this.update_options();
    },
  },
}
</script>
